import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import * as Sentry from "@sentry/react";

// Import the generated route tree
import { routeTree } from './routeTree.gen';

// Create a new router instance
const router = createRouter({ routeTree });

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

// Initialize Sentry only in production
if (import.meta.env.MODE === 'production' && import.meta.env.SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration()
    ],
    // Performance Monitoring
    tracesSampleRate: 0.4, // Capture 40% of transactions

    // Session Replay (Optional - uncomment if needed and integration added)
    replaysSessionSampleRate: 0.1, // Capture 10% of sessions
    replaysOnErrorSampleRate: 1.0, // Capture 100% of sessions with an error

    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/ebjoy\.com\/api/],

    // Optional: Send PII like user IP
    sendDefaultPii: true,

    // Optional: Set release based on an env var set during build/deploy
    // release: import.meta.env.APP_VERSION, 
  });
  console.log('Sentry initialized for production.');
} else {
  console.log(`Sentry not initialized (MODE: ${import.meta.env.MODE}, DSN Present: ${!!import.meta.env.SENTRY_DSN})`);
}

const rootEl = document.getElementById('root');
if (rootEl) {
  const root = ReactDOM.createRoot(rootEl);
  root.render(
    <React.StrictMode>
      <Sentry.ErrorBoundary fallback={<div>Something went wrong</div>}>
        <RouterProvider router={router} />
      </Sentry.ErrorBoundary>
    </React.StrictMode>,
  );
}
